(function(){
  'use strict';
  var path = window.location.pathname;

  /* === 1. /pages/countries-we-ship-currently 対応 === */
  if(path === '/pages/countries-we-ship-currently'){
    function fixCountriesPage(){
      var rte = document.querySelector('.rte');
      if(!rte) return;
      var html = rte.innerHTML;
      // 既に修正済みなら何もしない
      if(html.indexOf('Switzerland') !== -1 && html.indexOf('Bangladesh') !== -1 &&
         html.indexOf('Vietnam') !== -1 && html.indexOf('Hong Kong') !== -1) return;
      // 17カ国版で完全置換
      rte.innerHTML = [
        '<h2><span style="text-decoration: underline; color: rgb(255, 42, 0);"><strong>Free shipping for purchases of JPY 50,000 or more.</strong></span></h2>',
        '<h3>Countries we can ship to are :</h3>',
        '<h3>Asia</h3>',
        '<table><tbody>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="Malaysia" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/94511caaae2ec9ce3dd3e7b666ae9328_7e1508fd-9ddd-4236-9f28-9a0d5157beec_100x100.jpg?v=1579396623"></div><div>&nbsp;&nbsp;&nbsp;Malaysia</div></td>',
          '<td><div><img height="100" width="100" alt="Philippines" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/9d417d12c06e449ae9a6f2bd86bdd638_100x100.jpg?v=1579395977"></div><div>&nbsp;&nbsp;&nbsp;Philippines</div></td>',
          '<td><div><img height="100" width="100" alt="South Korea" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/08f0840d0810d0edcc97cc2095db00dc_100x100.jpg?v=1579396422"></div><div>&nbsp;&nbsp;&nbsp;South Korea</div></td>',
        '</tr>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="Singapore" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/9640265b3af689aff3ff2a6fc45fb4e5_100x100.jpg?v=1579396841"></div><div>&nbsp;&nbsp;&nbsp;Singapore</div></td>',
          '<td><div><img height="100" width="100" alt="Taiwan" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/811c148b30b2ba122b9006bdf259517d_100x100.jpg?v=1579397006"></div><div>&nbsp;&nbsp;&nbsp;Taiwan</div></td>',
          '<td><div><img height="100" width="100" alt="Thailand" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/9a2d2dd4610fc12509d921f64c36d26c_100x100.jpg?v=1579420405"></div><div>&nbsp;&nbsp;&nbsp;Thailand</div></td>',
        '</tr>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="Vietnam" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/485de5d0fc37b071226b1b102044d83f_100x100.jpg?v=1579421086"></div><div>&nbsp;&nbsp;&nbsp;Vietnam</div></td>',
          '<td><div><img height="100" width="100" alt="India" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/e73fd18c0c5da42533a403018c804fca_100x100.gif?v=1694848480"></div><div>&nbsp;&nbsp;&nbsp;India</div></td>',
          '<td><div><img height="100" width="100" alt="China" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/25a7a0e9cc5290074e97ceba29be8b51_100x100.jpg?v=1699178413"></div><div>&nbsp;&nbsp;&nbsp;China</div></td>',
        '</tr>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="Pakistan" src="https://cdn.shopify.com/s/files/1/0743/1759/4876/t/5/assets/flag-pakistan.png?v=1782140533"></div><div>&nbsp;&nbsp;&nbsp;Pakistan</div></td>',
          '<td><div><img height="100" width="100" alt="Bangladesh" src="https://cdn.shopify.com/s/files/1/0743/1759/4876/t/5/assets/flag-bangladesh.png?v=1782140534"></div><div>&nbsp;&nbsp;&nbsp;Bangladesh</div></td>',
          '<td></td>',
        '</tr>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="Hong Kong" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/816df0a630f120f1e5545e94ef812b9a_100x100.jpg?v=1704694007"></div><div>&nbsp;&nbsp;&nbsp;Hong Kong</div></td>',
          '<td></td>',
          '<td></td>',
        '</tr>',
        '</tbody></table>',
        '<h3>Oceania</h3>',
        '<table><tbody>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="Australia" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/e0207464058f63d0304bd6282ebba031_100x100.gif?v=1694848337"></div><div>&nbsp;&nbsp;&nbsp;Australia</div></td>',
          '<td><div><img height="100" width="100" alt="New Zealand" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/9f56f06fbeffe89672e1242b9cc71167_100x100.jpg?v=1661133717"></div><div>&nbsp;&nbsp;&nbsp;New Zealand</div></td>',
          '<td></td>',
        '</tr>',
        '</tbody></table>',
        '<h3>North America</h3>',
        '<table><tbody>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="USA" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/8df1ff7ebbd42c91c39ec35fd8099adb_100x100.png?v=1694847737"></div><div>&nbsp;&nbsp;&nbsp;USA</div></td>',
          '<td><div><img height="100" width="100" alt="Canada" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/e6e97161f1082de3a124b50d0db3501b_100x100.gif?v=1694848127"></div><div>&nbsp;&nbsp;&nbsp;Canada</div></td>',
          '<td></td>',
        '</tr>',
        '</tbody></table>',
        '<h3>Europe</h3>',
        '<table><tbody>',
        '<tr>',
          '<td><div><img height="100" width="100" alt="United Kingdom" src="https://cdn.shopify.com/s/files/1/0011/1689/7343/files/9995e7b17b3690b799bf319d599aa015_100x100.gif?v=1695045730"></div><div>&nbsp;&nbsp;&nbsp;United Kingdom</div></td>',
          '<td><div><img height="100" width="100" alt="Switzerland" src="https://cdn.shopify.com/s/files/1/0743/1759/4876/t/5/assets/flag-switzerland.png?v=1782140596"></div><div>&nbsp;&nbsp;&nbsp;Switzerland</div></td>',
          '<td></td>',
        '</tr>',
        '</tbody></table>'
      ].join('');
      console.log('[ZEN] countries-fix.js: /pages/countries-we-ship-currently updated to 17 countries.');
    }
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', fixCountriesPage);
    } else {
      fixCountriesPage();
    }
    return;
  }

  /* === 2. /pages/faq 対応 === */
  if(path === '/pages/faq'){
    function fixFaqPage(){
      var b = document.body;
      if(!b) return;
      var h = b.innerHTML;
      var oldText = 'We can ship to USA, Canada, UK, China, Malaysia, Philippines, South Korea, Singapore, Taiwan, Thailand, Viet Nam, India, Australia and New Zealand only.';
      var newText = 'We currently ship to the following 18 countries: <strong>United States, Canada</strong> (North America); <strong>United Kingdom, Switzerland</strong> (Europe); <strong>Australia, New Zealand</strong> (Oceania); <strong>China, South Korea, Taiwan, Hong Kong</strong> (East Asia); <strong>Singapore, Philippines, Malaysia, Thailand, Vietnam</strong> (Southeast Asia); <strong>India, Pakistan, Bangladesh</strong> (South Asia).';
      if(h.indexOf(oldText) === -1) return;
      b.innerHTML = h.split(oldText).join(newText);
      console.log('[ZEN] countries-fix.js: /pages/faq country list updated to 17 countries.');
    }
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', fixFaqPage);
    } else {
      fixFaqPage();
    }
    return;
  }

})();

